import React from 'react';
import "./ArticleList.scss";
import { Article } from "../";

const ArticleList = ({ children, flexDirection }) => {
    return (
        <div className="article-list" style={{ flexDirection: `${flexDirection}` }} >
            {children}
        </div>
    )
}

export default ArticleList;
